


export type BillFlowEvaluationValueMode = 'Present' | 'Missing' | 'Ignored';

export const BillFlowEvaluationValueMode = {
    Present: 'Present' as BillFlowEvaluationValueMode,
    Missing: 'Missing' as BillFlowEvaluationValueMode,
    Ignored: 'Ignored' as BillFlowEvaluationValueMode
};

